import { type FilterValues } from "components/filters/FilterContext";
import { mapArtistFilterToInstruction, mapFreefieldProfileFilterToInstruction, mapKeywordFilterToInstruction, mapResponseToArtistFilter, mapResponseToFreefieldProfileFilter, mapResponseToKeywordFilter, mapResponseToUserToClientLifecycleFilter, mapUserToClientLifecycleToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.ListExternalUserInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    freeFieldProfileIds: mapFreefieldProfileFilterToInstruction(filter.freefieldProfile),
    userToClientLifeCycles: mapUserToClientLifecycleToInstruction(filter.userToClientLifecycle),
    artistIds: mapArtistFilterToInstruction(filter.artist),
    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListExternalUserFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  freefieldProfile: mapResponseToFreefieldProfileFilter(response.freeFieldProfiles),
  userToClientLifecycle: mapResponseToUserToClientLifecycleFilter(response.userToClientLifeCycles),
  artist: mapResponseToArtistFilter(response.artists)
});